<template>
  <svg class="icon" :class="iconClass" :style="iconStyles">
    <use :xlink:href="iconName"></use>
  </svg>
</template>

<script>
import '../../assets/logo.svg';
import '../../assets/calendar.svg';
import '../../assets/check-circle.svg';
import '../../assets/currency-dollar.svg';
import '../../assets/currency-dollar-red.svg';
import '../../assets/accounting-document.svg';
import '../../assets/warning.svg';
import '../../assets/logo-white.svg';
import '../../assets/back-arrow.svg';
import '../../assets/pending-immigration-app.svg';
import '../../assets/pending-llc-app.svg';
import '../../assets/incomplete.svg';
import '../../assets/completed.svg';
import '../../assets/withdrawn.svg';
import '../../assets/under-review.svg';
import '../../assets/program-app.svg';
import '../../assets/financial-education.svg';
import '../../assets/survey.svg';
import '../../assets/menu.svg';
import '../../assets/dropdown.svg';
import '../../assets/close.svg';
import '../../assets/help-header.svg';
import '../../assets/help-tab.svg';
import '../../assets/sign-out.svg';
import '../../assets/home-active.svg';
import '../../assets/home-inactive.svg';
import '../../assets/pending-apps-active.svg';
import '../../assets/pending-apps-inactive.svg';
import '../../assets/active-programs-active.svg';
import '../../assets/active-programs-inactive.svg';
import '../../assets/closed-programs-active.svg';
import '../../assets/closed-programs-inactive.svg';
import '../../assets/resources-active.svg';
import '../../assets/resources-inactive.svg';
import '../../assets/google-play.svg';
import '../../assets/apple-store.svg';
import '../../assets/popup-home.svg';
import '../../assets/popup-pending-apps.svg';
import '../../assets/popup-active-programs.svg';
import '../../assets/popup-closed-programs.svg';
import '../../assets/lock.svg';
import '../../assets/lc-logo.svg';
import '../../assets/closed-popup.svg';
import '../../assets/date.svg';
import '../../assets/money-bag.svg';
import '../../assets/past-due.svg';
import '../../assets/charge-off.svg';
import '../../assets/check-account.svg';
import '../../assets/voided-check.svg';
import '../../assets/bank-statement.svg';
import '../../assets/letter-from.svg';
import '../../assets/direct-deposit.svg';
import '../../assets/valid-virtual-card.svg';

export default {
  name: 'svg-icon',
  props: {
    name: {
      type: String,
      default() {
        return '';
      },
    },
    width: {
      type: Number,
      default() {
        return 20;
      },
    },
    height: {
      type: Number,
      default() {
        return 20;
      },
    },
  },
  computed: {
    iconStyles() {
      return `
        width: ${this.width}px;
        height: ${this.height}px;
      `;
    },
    iconName() {
      return `#${this.name}`;
    },
    iconClass() {
      return `${this.name}-icon`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './../../sass/main.scss';

.icon {
  align-items: center;
  vertical-align: middle;
  font-weight: normal;
  font-style: normal;
  font-size: $font-size-largest;
  fill: currentColor;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  color: $font-color-dark;
  height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/SvgIcon.vue